import { ChatMachineContext } from './ChatMachineContext';
import { ChatMessage } from './chatMachine.types';
import { FeedbackType } from '@/apiTypes/AiTypes';

export const useChatMachine = () => {
    const actorRef = ChatMachineContext.useActorRef();
    const messages = ChatMachineContext.useSelector(state => state.context.messages);
    const inputMessage = ChatMachineContext.useSelector(state => state.context.inputMessage);
    const isStreaming = ChatMachineContext.useSelector(state => state.matches('streaming'));
    const currentError = ChatMachineContext.useSelector(state => state.context.currentError);
    const aiContext = ChatMachineContext.useSelector(state => state.context.aiContext);
    const prePrompts = ChatMachineContext.useSelector(state => state.context.prePrompts);
    const prePromptsWereSet = ChatMachineContext.useSelector(state => state.context.prePromptsWereSet);
    const conversationId = ChatMachineContext.useSelector(state => state.context.conversationId);
    const messageFeedback = ChatMachineContext.useSelector(state => state.context.messageFeedback);
    const placeholderMap = ChatMachineContext.useSelector(state => state.context.placeholderMap);

    return {
        messages,
        inputMessage,
        isStreaming,
        currentError,
        aiContext,
        prePrompts,
        prePromptsWereSet,
        conversationId,
        messageFeedback,
        placeholderMap,
        send: actorRef.send,
        setInput: (value: string) => actorRef.send({ type: 'SET_INPUT', value }),
        sendMessage: () => actorRef.send({ type: 'SEND_MESSAGE' }),
        clearMessages: () => actorRef.send({ type: 'CLEAR_MESSAGES' }),
        cancelStream: () => actorRef.send({ type: 'CANCEL_STREAM' }),
        sendPrePrompt: (prompt: string) => actorRef.send({ type: 'SEND_PRE_PROMPT', prompt }),
        loadConversation: (conversationId: string, messages: ChatMessage[], feedback?: Record<string, { type: FeedbackType; id: string }>) =>
            actorRef.send({ type: 'LOAD_CONVERSATION', conversationId, messages, feedback }),
        startNewConversation: () => actorRef.send({ type: 'START_NEW_CONVERSATION' }),
        setMessageFeedback: (messageId: string, feedbackType: FeedbackType, feedbackId: string) =>
            actorRef.send({ type: 'SET_MESSAGE_FEEDBACK', messageId, feedbackType, feedbackId }),
    };
};
